import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Box, Button, DialogActions, DialogContent, DialogContentText, MenuItem, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { CompanyType } from 'models/CompanyModel';
import { CarModel } from 'models/StockModel';
import companyList from 'recoil/atoms/companyList';


type ShipperDialogProps = {
    car: CarModel,
} & ModalActionProps<number>;

const ShipperDialog = ({car, onFinish}: ShipperDialogProps) => {
    const {t} = useTranslation('cars');
    const companies = useRecoilValue(companyList(CompanyType.Shipper));

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onFinish(Number(new FormData(event.currentTarget).get('shipper') as string));
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <DialogContentText>
                    {car.model} {car.chassisNumber} <br/>
                    {t('current_shipper')}: {car.company.name}
                </DialogContentText>

                <TextField
                    id="companyId"
                    name="shipper"
                    label={t('select_new_shipper')}
                    fullWidth
                    required
                    select
                    defaultValue={car.company.id || ''}
                >
                    {companies.map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
                </TextField>
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('apply')}</Button>
            </DialogActions>
        </Box>
    );
};

export default ShipperDialog;
